import { useState, useEffect } from 'react';
import Button from '../inputs/Button';

type NavigationPromptModalProps = {
  onConfirm: boolean | (() => void);
  onCancel: boolean | (() => void);
  show: true | (() => void);
  confirmLabel?: string;
  cancelLabel?: string;
  directions?: React.ReactNode;
};

export default function NavigationPromptModal({
  onConfirm,
  onCancel,
  show,
  confirmLabel,
  cancelLabel,
  directions,
}: NavigationPromptModalProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (show) {
      setIsOpen(true);
    }
  }, [show]);

  return (
    <div
      className={`absolute max-w-full max-h-full inset-0 z-50 flex justify-center items-center transition-all duration-300 ease-in-out ${
        isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-125'
      }`}
    >
      <div className="z-50 w-3/4 lg:w-1/2 xl:w-2/5 bg-white rounded-half p-5 min-w-min min-h-min">
        <div className="h-full w-full flex flex-col">
          <div className="flex flex-col flex-grow pt-2">
            <div className="flex flex-grow-0 justify-center">
              <h4>Unsaved Changes</h4>
            </div>
            <div className="flex flex-col flex-grow justify-center items-center w-full pb-10 pt-2 space-y-2 text-center">
              {directions && <>{directions}</>}
              {!directions && (
                <>
                  <p>You have unsaved changes.</p>
                  <p>If you navigate away your unsaved changes will be lost.</p>
                  <p>
                    To save your audience click "Return to save" and then "Save
                    audience".
                  </p>
                </>
              )}
            </div>
          </div>
          <div className="flex flex-grow-0 justify-center pb-8 space-x-3">
            <Button
              type="button"
              secondary
              onClick={typeof onConfirm === 'function' ? onConfirm : () => {}}
            >
              {confirmLabel || 'Leave'}
            </Button>
            <Button
              type="button"
              primary
              onClick={typeof onCancel === 'function' ? onCancel : () => {}}
            >
              {cancelLabel || 'Return to save'}
            </Button>
          </div>
        </div>
      </div>
      {show && (
        <button className="absolute h-screen w-screen bg-gray-500 opacity-50 cursor-default"></button>
      )}
    </div>
  );
}
